<div class="message-modal" (keydown)="handleKeydown($event)" *ngIf="jsonRes">
        {{loadFocusTelements()}}
    <div class="modal-header">
        <h2 id='modalHeading' tabindex="0">{{jsonRes.heading_lock}}</h2>
    </div>
    <div class="corner-button">
        <button class="close" aria-label="Close" (click)="cancelModal(false)"tabindex="0">x</button>
    </div>
    <div class="modal-body">
        <div>{{jsonRes.ctn}}: {{ctn}} </div>
        <div>{{jsonRes.fan}}: {{fan}}</div>
        <div>{{jsonRes.ban}}: {{ban}}</div>
        <br>
        <div class = "description">{{jsonRes.lock_description_1}}</div>
        <div class = "description">{{jsonRes.lock_description_2}}</div>
    </div>
    <div class="text-right modal-footer row">
        <button class="btn btn-secondary col-md-5 col-sm-12 pull-right" tabindex="0" (click)="ok()" id="device-lock-btn" checkImpersonator>{{jsonRes.buttons.ok}}</button>
        <a class="btn btn-link btn-block col-md-6 col-sm-12 btn-cancel pull-right text-right cancel-button-modal" tabindex="0" (click)="dimissModal(false)" (keydown)="dimissModal(false, $event)">{{jsonRes.buttons.cancel}}</a>
       
    </div>
</div>